import axios from 'axios';
import qs from 'qs';
import * as constants from '../../util/constants';
import helpers from '../../util/helpers';

const searchGlobal = () => {
  jQuery(document).ready(function($) {
    const loadFeed = (wrapper, results, maxResults = -1) => {
      if (results.length) {
        let html = '';
        results.forEach((result, i) => {
          if ((maxResults === -1) || (i < maxResults)) {
            const isOpenInNewTab = 'new_tab' in result && result['new_tab'];
            const isNew = 'is_new' in result && result['is_new'];

            html += `<li><a href="${result['permalink']}" target="${isOpenInNewTab ? '_blank' : '_self'}">${result['name']}</a>${isNew ? '<span class="item-tag">new</span>' : ''}</li>`;
          }
        });
        wrapper.html(html);
      } else {
        wrapper.html('<li>No matches found</li>');
      }
    };
    const globalSearch = $('.search-global');

    if (globalSearch.length) {
      const feeds = globalSearch.find('[data-feed-key]');
      const resultsLoadingRow = globalSearch.find('.results-loading-row');

      // Searching
      globalSearch.on('input', '.global-search-input', function() {
        const _this = $(this);
        const thisInputVal = _this.val();

        // Update value of other search input
        globalSearch.find('.global-search-input').not(_this).val(thisInputVal);

        if ('' === thisInputVal.trim()) {
          globalSearch.find('.recent-searches-row').removeClass('d-none');
        } else {
          globalSearch.find('.recent-searches-row').addClass('d-none');
        }

        if (globalSearch.hasClass('autocomplete-data-loaded')) {
          if ('' === thisInputVal.trim()) {
            globalSearch.find('.search-results-row').addClass('d-none');
            globalSearch.find('.collapse, [data-toggle="collapse"]').removeClass('show').addClass('collapsed');
          } else {
            globalSearch.find('.search-results-row').removeClass('d-none');
            globalSearch.find('.collapse, [data-toggle="collapse"]').addClass('show').removeClass('collapsed');
          }

          feeds.each(function() {
            const feed = $(this);
            const results = feed.data('feed').filter((item) => {
              const valueMatchName = item.name.toLowerCase().indexOf(thisInputVal.toLowerCase()) >= 0;
              let valueMatchKeyword = false;

              if ('keywords' in item && item.keywords) {
                const keywords = item.keywords.split(/,\s*/);

                for (let i = 0; i < keywords.length; i++) {
                  if (keywords[i].toLowerCase().indexOf(thisInputVal.toLowerCase()) >= 0) {
                    valueMatchKeyword = true;
                    break;
                  }
                }
              }

              return valueMatchName || valueMatchKeyword;
            });
            let maxResults = -1;
            if (feed.data('feed-max')) {
              maxResults = parseInt(feed.data('feed-max'));
            }

            loadFeed(feed, results, maxResults);
          });

          globalSearch.find('.search-hotel-col').each(function() {
            const col = $(this);
            const lists = col.find('ul[data-feed-key]');
            let hasResults = false;

            lists.each(function() {
              const ul = $(this);
              const html = ul.html().trim();

              if (html !== '' && html !== '<li>No matches found</li>') {
                hasResults = true;
                return false;
              }
            });

            if (hasResults) {
              col.removeClass('d-none');
            } else {
              col.addClass('d-none');
            }
          });

          const noResults = globalSearch.find('.search-hotel-col').filter(':visible').length === 0;
          if (noResults) {
            globalSearch.find('.no-results-message-col').removeClass('d-none');
          } else {
            globalSearch.find('.no-results-message-col').addClass('d-none');
          }
        } else {
          if ('' === thisInputVal.trim()) {
            resultsLoadingRow.addClass('d-none');
          } else {
            resultsLoadingRow.removeClass('d-none');
          }
        }
      });

      $(document).on('click', '.global-search-btn, .mobile-menu-toggle', function() {
        if (!globalSearch.hasClass('autocomplete-data-loaded')) {
          const data = {
            'action': constants.ACTION_GET_GLOBAL_SEARCH_AUTOCOMPLETE_DATA,
          };

          // Send request
          axios.post(window.Rydges['ajaxUrl'], qs.stringify(data)).then((axiosResponse) => {
            if (200 === axiosResponse.status) {
              const response = axiosResponse.data;

              if (response.success) {
                const autoCompleteData = response.data;

                // First load
                feeds.each(function() {
                  const feed = $(this);
                  const feedKey = feed.data('feed-key');

                  feed.data('feed', autoCompleteData[feedKey]);
                });

                // Activate global search input
                globalSearch.addClass('autocomplete-data-loaded');
                globalSearch.find('.global-search-input').trigger('input');
                resultsLoadingRow.addClass('d-none');
              }
            }
          }).catch((error) => {
            console.log(error);
          });
        }
      });

      // Load recent searches
      const recentSearches = JSON.parse(helpers.docCookies.getItem(constants.COOKIE_KEY_GLOBAL_SEARCH_RECENT)) || [];
      if (null !== recentSearches && recentSearches.length) {
        globalSearch.find('.recent-searches').html(
          '<h2>Recent Searches</h2>' +
          '<ul>' +
          recentSearches.map((recentSearch) => {
            return `<li><a href="${recentSearch['url']}" target="${'target' in recentSearch ? recentSearch['target'] : '_self'}">${recentSearch['text']}</a></li>`;
          }).join('') +
          '</ul>'
        );
      }

      // Save recent searches
      globalSearch.on('click', '.search-results-row a', function() {
        const recentSearches = JSON.parse(helpers.docCookies.getItem(constants.COOKIE_KEY_GLOBAL_SEARCH_RECENT)) || [];
        const _this = $(this);

        if (null !== recentSearches) {
          const data = {
            url: _this.attr('href'),
            text: _this.text(),
            target: _this.attr('target'),
          };

          if (JSON.stringify(recentSearches[0]) !== JSON.stringify(data)) {
            recentSearches.unshift(data);
          }

          // Save last 3 searches to cookie
          helpers.docCookies.setItem(constants.COOKIE_KEY_GLOBAL_SEARCH_RECENT, JSON.stringify(recentSearches.slice(0, 3)), 30 * 86400, '/');
        }
      });
    }
  });
};

export default searchGlobal;



// WEBPACK FOOTER //
// ./scripts/routes/modules/searchGlobal.js